import React from 'react'
import withStyles from '@mui/styles/withStyles';
import { IconButton, Button } from '@mui/material'
import CloseIcon from '@mui/icons-material/Close'
import AddIcon from '@mui/icons-material/Add'

const styles = theme => ({
    column: {
        display: 'flex',
        flexFlow: 'column nowrap'
    },
    row: {
        display: 'flex',
        marginBottom: theme.spacing(1)
    },
    removeBtn: {
        alignSelf: 'center',
        marginLeft: theme.spacing(0.5)
    },
    addBtn: {
        alignSelf: 'flex-start'
    }
})

const EditableList = props => {
    const {
        classes,
        children,
        onRemove,
        onAdd
    } = props
    return (
        <div className={classes.column}>
            {React.Children.map(children, (child, i) => (
                <div className={classes.row}>
                    {child}
                    <IconButton className={classes.removeBtn} onClick={() => onRemove(i)} size="large">
                        <CloseIcon fontSize="small" />
                    </IconButton>
                </div>
            ))}
            <Button className={classes.addBtn} onClick={onAdd} variant="contained">
                <AddIcon fontSize="small" />
                {'Add Row'}
            </Button>
        </div>
    );
}

export default withStyles(styles)(EditableList)
